<template>
  <div>
    <v-card class="rounded-lg elevation-3 overflow-hidden">
      <!-- Toolbar Header Principal estilo Inspección / Cliente -->
      <v-toolbar height="58" color="secondary" dark flat class="px-3">
        <div class="d-flex align-center">
          <v-icon left>mdi-account-group</v-icon>
          <span class="text-h6 font-weight-medium">
            {{ Titulo || "Gestión de Usuarios por Cliente" }}
          </span>
          <v-chip
            small
            color="white"
            text-color="secondary"
            class="font-weight-bold ml-3 px-3 elevation-1"
            style="font-size: 0.95rem; height: 32px"
          >
            <v-icon left size="18" color="secondary">mdi-counter</v-icon>
            {{ Items ? Items.length : 0 }} Clientes
          </v-chip>
        </div>

        <v-spacer></v-spacer>

        <!-- Botón de Ayuda -->
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mx-1 btn-circle-tooltip"
              icon
              dark
              target="_blank"
              :href="global.helpdesk_url + 'usuarios_por_cliente'"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon size="25" color="amber lighten-2">mdi-help-circle-outline</v-icon>
            </v-btn>
          </template>
          <span>¿Necesitas ayuda?</span>
        </v-tooltip>
      </v-toolbar>

      <!-- Sección de Búsqueda y Acciones -->
      <div class="pa-4 pb-2">
        <v-row dense class="align-center mb-1">
          <!-- Búsqueda Rápida -->
          <v-col cols="12" md="7">
            <v-text-field
              v-model="search"
              outlined
              dense
              single-line
              hide-details
              prepend-inner-icon="mdi-magnify"
              clearable
              label="Búsqueda rápida"
              placeholder="Buscar por nombre de cliente, razón social o ID..."
              class="rounded-lg"
            ></v-text-field>
          </v-col>

          <!-- Botones de Acción -->
          <v-col cols="12" md="5" class="d-flex align-center justify-end flex-wrap gap-2">
            <!-- Descargar Excel -->
            <v-btn
              v-if="Excel"
              color="success"
              dark
              height="38"
              class="px-4 font-weight-bold elevation-1 text-none rounded-lg"
              @click="DescargarExcel()"
            >
              <v-icon left size="18">mdi-file-excel</v-icon>
              Descargar Tabla
            </v-btn>
          </v-col>
        </v-row>
      </div>

      <!-- Tabla Principal -->
      <div class="table-responsive-wrapper">
        <v-data-table
          dense
          :headers="Cabecera"
          :items="Items"
          :items-per-page="10"
          :search="search"
          class="modern-table elevation-0"
          loading-text="Cargando usuarios por cliente... Por favor, espere"
          :loading="Loading"
          no-data-text="No hay clientes con usuarios disponibles"
          :footer-props="{
            'items-per-page-text': 'Resultados por página:',
            'items-per-page-options': [5, 10, 25, 50],
            'page-text': '{0}-{1} de {2}'
          }"
        >
          <!-- Columna ID -->
          <template v-slot:[`item.id`]="{ item }">
            <span class="font-weight-bold font-mono text--secondary">
              #{{ item.id }}
            </span>
          </template>

          <!-- Columna Cliente / Razón Social -->
          <template v-slot:[`item.razon_social`]="{ item }">
            <div class="d-flex align-center">
              <v-avatar size="32" color="blue-grey lighten-5" class="mr-3 elevation-1">
                <v-icon small color="blue-grey darken-2">mdi-domain</v-icon>
              </v-avatar>
              <div>
                <span class="font-weight-bold text-body-2 text--primary">{{ item.razon_social }}</span>
              </div>
            </div>
          </template>

          <!-- Columna Miembros Asignados -->
          <template v-slot:[`item.miembros`]="{ item }">
            <v-chip
              small
              :color="parseInt(item.miembros) > 0 ? 'teal lighten-5' : 'grey lighten-4'"
              :text-color="parseInt(item.miembros) > 0 ? 'teal darken-3' : 'grey darken-1'"
              class="font-weight-bold elevation-1 px-3"
            >
              <v-icon left x-small :color="parseInt(item.miembros) > 0 ? 'teal darken-2' : 'grey'">
                mdi-account-multiple
              </v-icon>
              {{ item.miembros || 0 }} {{ parseInt(item.miembros) === 1 ? 'usuario' : 'usuarios' }}
            </v-chip>
          </template>

          <!-- Columna Acciones -->
          <template v-slot:[`item.accion`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  class="action-btn elevation-1 text-none font-weight-medium rounded-lg px-3"
                  small
                  dark
                  @click="verMiembros(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon left small>mdi-account-search</v-icon>
                  Ver Miembros
                </v-btn>
              </template>
              <span>Gestionar miembros de {{ item.razon_social }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import router from '@/router';
import exportFromJSON from 'export-from-json';
import global from '@/global';

export default {
  props: ['Titulo', 'Cabecera', 'Items', 'Excel', 'Crear', 'Loading'],
  data() {
    return {
      search: '',
      global: global
    };
  },
  computed: {
    ...mapState('navigation', ['Permisos'])
  },
  methods: {
    verMiembros(item) {
      router.push('/miembroscliente/' + item.id);
    },

    DescargarExcel() {
      const data = this.Items;
      const nombreArchivo = 'usuarios_por_cliente_' + new Date().toISOString().slice(0, 10);
      const exportType = exportFromJSON.types.xls;
      exportFromJSON({ data, nombreArchivo, exportType });
    }
  }
};
</script>

<style scoped>
.modern-table ::v-deep thead tr:not(.v-data-table__progress) th {
  background-color: #424242 !important;
  color: #ffffff !important;
  font-size: 0.84rem !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px;
  white-space: nowrap;
  height: 44px !important;
  border-bottom: none !important;
}

.modern-table ::v-deep thead tr:not(.v-data-table__progress) th .v-icon {
  color: #ffffff !important;
}

.modern-table ::v-deep thead tr:not(.v-data-table__progress) th:hover {
  background-color: #333333 !important;
}

.modern-table ::v-deep thead tr.v-data-table__progress th {
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
  height: auto !important;
}

.modern-table ::v-deep .v-data-table__empty-wrapper td {
  background: transparent !important;
  background-color: transparent !important;
}

.modern-table ::v-deep td {
  font-size: 0.85rem !important;
  padding: 10px 14px !important;
  border-bottom: 1px solid #f1f5f9 !important;
  vertical-align: middle;
}

.modern-table ::v-deep tbody tr:hover {
  background-color: #f8fafc !important;
  transition: background-color 0.15s ease-in-out;
}

.modern-table ::v-deep .v-data-footer {
  border-top: 1px solid #e2e8f0;
  background-color: #f8fafc;
  font-size: 0.82rem;
  padding: 8px 16px;
}

.table-responsive-wrapper {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-responsive-wrapper::-webkit-scrollbar {
  height: 6px;
}

.table-responsive-wrapper::-webkit-scrollbar-track {
  background: #f1f5f9;
}

.table-responsive-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.table-responsive-wrapper::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.action-btn {
  transition: transform 0.18s ease-in-out, box-shadow 0.18s ease-in-out !important;
}

.action-btn:hover {
  transform: scale(1.04) !important;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2) !important;
}

.font-mono {
  font-family: monospace, 'Courier New', Courier;
}

.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip ::v-deep .v-btn__content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100% !important;
  line-height: 1 !important;
}

.btn-circle-tooltip ::v-deep .v-icon {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
}
</style>
